// INFO: to add new global colors in css - copy constants to colorsForScript.mjs and execute npm run inject-colors script
// INFO 2: to use them with jss - import values from lib/cssSeelctor
export const colors = {
  mainLight: '#EAF1FF',
  mainLightHover: '#DFE9FE',

  main: '#286DFA',
  mainHover: '#184296',
  mainActive: '#2563EB', // WCAG AA compliant - 4.52:1 contrast ratio

  mainDark: '#1E53BC',
  mainDarkHover: '#184296',

  reward: '#FB923C',
  rewardLight: '#FFFBEB',

  success: '#22C55E',
  successDark: '#166534',
  successLight: '#DDFCE8',

  border: '#94A3B8',
  background: '#F8FAFC',
  contentBg: '#FFFFFF',
  error: '#DE350B',

  // do not use those keys
  white: '#FFFFFF',
  lightGreen: '#DDFCE8',
  lightMain: '#EFF6FF',
  lightYellow: '#FFFBEB',
  green: '#22C55E',
  red: '#EF4444',
  lightGray: '#F3F4F6',
  lightGray1: '#E1E7F1',
  gray: '#DDDDDD'
}

export const textColors = {
  main: '#0F172A',
  sub: '#475569',
  mainContrast: '#FFFFFF',
  placeholder: '#94A3B8',
  success: '#069438',

  // do not use those keys
  black: '#000000',
  dark: '#181818',
  darkGray: '#424242',
  gray: '#828282',
  lightGray: '#D1D5DB',
  white: '#FFFFFF',
  green: '#069438',
  yellow: '#D97706'
}

export const linearGroups = {
  mainDark: ['#0F172A', '#1E293B'],
  pageBG: ['#F8FAFC', '#EFF6FF'],
  reward: ['#EAB308', '#F59E0B'],
  rewardDark: ['#CA8A04', '#D97706'],
  success: ['#4ADE80', '#22C55E'],

  // do not use those keys
  bluePurple: ['#2563EB', '#9333EA'],
  orange: ['#F97316', '#EF4444'],
  green: ['#34D399', '#14B8A6'],
  blue: ['#60A5FA', '#6366F1']
}

export default { colors, textColors, linearGroups }
